<template>
  <div class="doctor-card">
    <Image
      :src="doctor.image"
      alt="Doctor"
      width="100"
      height="120"
      class="doctor-image"
      imageStyle="object-fit: cover; border-radius: 8px;"
    />

    <div class="doctor-info text-start">
      <h3 class="doctor-name mb-1" style="line-height: 1">{{ doctor.name }}</h3>
      <p class="doctor-specialty pb-0 mb-2" style="line-height: 1.1">
        {{ doctor.specialty }}
        <!--   <span style="display: block; font-size: 13px"
          >({{ doctor.reviews }} отзывов)</span
        > -->
      </p>
      <p class="doctor-experience mt-0 pt-0 pb-0 mb-0">
        {{ doctor.scstatus ? doctor.scstatus + ", " : "" }}стаж
        {{ doctor.experience }} лет
      </p>
      <div class="doctor-stats mt-0 pt-0 pb-0 mb-0">
        <div class="stat pt-1">
          <i class="pi pi-users people"></i>
          <span style="line-height: 1"
            >Пациентов
            <span
              style="
                font-weight: bold;
                font-size: 12px;
                line-height: 1;
                color: #4caf50;
              "
              >{{ doctor.patients }}+</span
            ></span
          >
        </div>
        <div class="stat">
          <i class="pi pi-star-fill star"></i>
          <span style="line-height: 1"
            >Рейтинг
            <span style="font-weight: bold; font-size: 12px; line-height: 1">{{
              doctor.rating
            }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Image from "primevue/image";

export default {
  name: "DoctorCard",
  components: { Image },
  props: {
    doctor: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.doctor-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.doctor-image {
  width: 100px;
  height: 120px;
  border-radius: 12px;
  object-fit: cover;
  margin-right: 16px;
  border: 0px solid #4caf50;
}

.ttimg {
  border-radius: 12px !important;
  object-fit: cover !important;
}
.doctor-info {
  flex: 1;
}

.doctor-name {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  white-space: pre-wrap;
}

.doctor-specialty {
  font-size: 14px;
  color: #6b6b6b;
}

.doctor-specialty span {
  font-weight: normal;
  color: #9e9e9e;
}

.doctor-experience {
  font-size: 14px;
  color: #6b6b6b;
}

.doctor-stats {
  display: flex;
  margin-top: 8px;
}

.stat {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.stat i.people {
  color: #4caf50;
  margin-right: 6px;
  border: 1px solid #4caf50;
  border-radius: 5px;
  padding: 4px;
}
.stat i.star {
  color: #ffd800;
  margin-right: 6px;
  padding: 4px;
}

.stat span {
  font-size: 14px;
  color: #6b6b6b;
}
</style>
